export const KEY_CODE = {
    ENTER: 13,
    DOWN: 40,
    UP: 38
};

export const EXTERNAL_URL = {
    // jodoo 人机验证
    // eslint-disable-next-line @fx-ui/jdy-design/no-blacklist-constant
    CLOUDFLARE_TURNSTILE_URL: 'https://challenges.cloudflare.com/turnstile/v0/api.js',
    // https://developers.google.com/recaptcha/docs/faq?hl=zh-cn#can-i-use-recaptcha-globally
    // eslint-disable-next-line @fx-ui/jdy-design/no-blacklist-constant
    GOOGLE_RECAPTCHA_URL: 'https://www.recaptcha.net/recaptcha/api.js'
};

export const TEXT_TYPE_REGEXP = {
    // 手机号码
    MOBILE: '^((\\(\\d{2,3}\\))|(\\d{3}\\-))?1\\d{10}$',
    // 电子邮箱
    EMAIL: '^([a-zA-Z0-9_\\.\\-])+\\@(([a-zA-Z0-9\\-])+\\.)+([a-zA-Z0-9]{2,4})+$',
    // 国际手机号码
    INTER_MOBILE: '^\\+?(\\d{1,4}-)?\\d{7,}$'
};
